import { render, staticRenderFns } from "./hubWisePerformanceReport_KSA_new.vue?vue&type=template&id=069b5d33&"
import script from "./hubWisePerformanceReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./hubWisePerformanceReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports